module.exports = __webpack_public_path__ + "media/images/brand/twitter_link-c014227c63a4b4cf9a7a0a134d13618c.svg";